import { ArrowRightIcon, Button, Header, Paragraph } from "@datagame/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useWordopolis } from "../../../../hooks/useWordopolis";
import { WordopolisModal } from "../WordopolisModal";
import wordopolisOutOfTime from "../../../../assets/images/wordopolisOutOfTime.png";
import wordopolisWin from "../../../../assets/images/wordopolisWin.png";

import styles from "./FinishGameModal.module.scss";

export interface FinishGameModalProps {
  onFinish: () => void;
}

export const FinishGameModal = ({ onFinish }: FinishGameModalProps) => {
  const [
    {
      configuration: {
        words,
        gameVisuals: { themeColor },
      },
      status: { isGameFinished, foundWords, toRate },
    },
  ] = useWordopolis();
  const isGameWon = words.length === foundWords.length;
  const { t: translate } = useTranslation();
  const [hasBeenRated, setHasBeenRated] = useState(false);
  const t = (key: string) => translate(`wordopolis.modals.finish.${key}.${isGameWon ? "win" : "lose"}`);

  useEffect(() => {
    if (isGameFinished && toRate.length) {
      setHasBeenRated(true);
    }
  }, [isGameFinished, toRate]);

  return (
    <WordopolisModal
      isVisible={isGameFinished && !toRate.length}
      className={styles.wrapper}
      portalClassName={hasBeenRated ? undefined : styles.delayed}
    >
      <img className={styles.image} src={isGameWon ? wordopolisWin : wordopolisOutOfTime} alt="wordopolis reuslt" />
      <Header variant="h6" className={styles.header}>
        {t("header")}
      </Header>
      <Paragraph className={styles.paragraph} color="secondary" size="small">
        {t("description")}
      </Paragraph>
      <Button
        customColor={themeColor}
        icon={<ArrowRightIcon />}
        iconSide="left"
        className={styles.submitButton}
        onClick={onFinish}
      >
        {translate("continue")}
      </Button>
    </WordopolisModal>
  );
};
